import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Stack,
} from "@mui/material";

const FIELD_TYPES = [
  "text",
  "number",
  "email",
  "date",
  "checkbox",
  "select",
];

const FieldEditorModal = ({ open, onClose, field, onSave }) => {
  const [data, setData] = useState({
    label: "",
    type: "text",
    required: false,
    options: [],
  });

  useEffect(() => {
    if (field) setData(field);
  }, [field]);

  const handleSave = () => {
    onSave({
      ...data,
      id: field?.id || crypto.randomUUID(),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        {field ? "Modifier le champ" : "Ajouter un champ"}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={2}>
          <TextField
            label="Label"
            value={data.label}
            onChange={(e) => setData({ ...data, label: e.target.value })}
            fullWidth
          />

          <TextField
            select
            label="Type"
            value={data.type}
            onChange={(e) => setData({ ...data, type: e.target.value })}
            fullWidth
          >
            {FIELD_TYPES.map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </TextField>

          <FormControlLabel
            control={
              <Checkbox
                checked={data.required}
                onChange={(e) =>
                  setData({ ...data, required: e.target.checked })
                }
              />
            }
            label="Champ obligatoire"
          />

          {data.type === "select" && (
            <TextField
              label="Options (séparées par des virgules)"
              value={data.options.join(",")}
              onChange={(e) =>
                setData({
                  ...data,
                  options: e.target.value.split(",").map((s) => s.trim()),
                })
              }
              fullWidth
            />
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button variant="contained" onClick={handleSave}>
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FieldEditorModal;
